// extracted by mini-css-extract-plugin
export default {"MessagesList":"MessagesList_MessagesList__ug6C8","Button":"MessagesList_Button__1VWPf"};